const defaultEntityState = {
  title: "",
  category: 0,
  language: 0,
  author: "",
  entityId: "",
  library: 0,
  status: [],
  currentPage: 1,
};

const defaultState = {
  news: { ...defaultEntityState },
  videos: { ...defaultEntityState },
  podcasts: { ...defaultEntityState },
  events: { ...defaultEntityState },
  galleries: { ...defaultEntityState },
  documents: { ...defaultEntityState },
  links: { ...defaultEntityState },
};

const mergeEntitySlice = (current, incoming = {}) => ({
  title:       incoming.title       ?? current.title,
  category:    incoming.category    ?? current.category,
  language:    incoming.language    ?? current.language,
  reference:   incoming.reference   ?? current.reference,
  author:      incoming.author      ?? current.author,
  entityId:    incoming.entityId    ?? current.entityId,
  library:     incoming.library     ?? current.library,
  status:      incoming.status      ?? current.status,
  currentPage: incoming.currentPage ?? current.currentPage,
});

export const entityFiltersReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "UPDATE_ENTITY_FILTERS":
      return Object.keys(defaultState).reduce((acc, entityType) => {
        acc[entityType] = mergeEntitySlice(
          state[entityType],
          action.payload[entityType]
        );
        return acc;
      }, {});

    case "RESET_ENTITY_FILTERS":
      return {
        ...state,
        [action.payload.entityType]: {
          ...defaultEntityState,
          title:     state[action.payload.entityType].title,
          category:  state[action.payload.entityType].category,
          reference: state[action.payload.entityType].reference,
        },
      };

    default:
      return state;
  }
};